import React, { useEffect, useState } from 'react';

export default function LoadingScreen() {
  const [quoteIndex, setQuoteIndex] = useState(0);
  const quotes = [
    "Securing Your Financial Future...",
    "Empowering Communities Since Excellence...",
    "Smart Banking, Trusted Partnership...",
    "Connecting Trust with Digital Innovation..."
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setQuoteIndex((prev) => (prev + 1) % quotes.length);
    }, 1800);
    return () => clearInterval(interval);
  }, [quotes.length]);

  return (
    <div className="fixed inset-0 z-[9999] bg-navy flex flex-col items-center justify-center text-white">
      <div className="space-y-8 flex flex-col items-center text-center">
        {/* Logo Container (Enlarged) */}
        <div className="h-36 w-36 rounded-3xl bg-white p-4 flex items-center justify-center shadow-2xl shadow-black/40 transform hover:scale-105 transition-transform duration-300">
          <img src="/Sahyadri Urban Logo.png" alt="Sahyadri Urban Logo" className="h-24 w-auto object-contain" />
        </div>

        {/* Branding text */}
        <div>
          <h2 className="font-montserrat font-extrabold text-3xl tracking-wider text-white">
            SAHYADRI
          </h2>
          <p className="text-[12px] text-golden font-semibold tracking-widest uppercase mt-1">
            Urban Co-operative Credit Society
          </p>
        </div>

        {/* Loader Circle Animation (Moved below logo & branding) */}
        <div className="h-10 w-10 rounded-full border-4 border-t-golden border-r-white/40 border-b-white/10 border-l-white/10 animate-spin" />

        {/* Dynamic Fading Quotes */}
        <div className="h-6">
          <p className="text-sm font-poppins text-gray-400 animate-pulse font-light">
            {quotes[quoteIndex]}
          </p>
        </div>
      </div>
    </div>
  );
}
